import type { Nullable } from "@core/domain/types/nullable.type";
import type { LayerDto } from "@farm/data/dto/layer.dto";
import { LayerDtoSchema } from "@farm/data/dto/layer.dto";
import { Layer } from "@farm/domain/models/layer.model";
import type { ModelError } from "@iot-platform/core";
import { NonRecuperableModelError } from "@iot-platform/core";
import { injectable } from "inversify";
import { err, Result } from "neverthrow";

@injectable()
export class LayerMapper {
    map(
        responseDto: LayerDto,
    ): Result<Nullable<Layer>, ModelError<typeof Layer>> {
        const parsedLayer = LayerDtoSchema.safeParse(responseDto);

        if (!parsedLayer.success) {
            console.error(parsedLayer.error.issues);
            return err(new NonRecuperableModelError());
        }

        return Layer.create({
            url: parsedLayer.data.url,
        }).mapErr(() => new NonRecuperableModelError());
    }
}
